const UTC_OFFSET_REGEX = /([zZ]|[+-]\d{2}:\d{2}|[+-]\d{4})$/;

export const parseBackendUtcDateTime = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    const parsedFromNumber = new Date(value);
    return Number.isNaN(parsedFromNumber.getTime()) ? null : parsedFromNumber;
  }

  if (typeof value !== 'string') return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  const normalized = trimmed.replace(' ', 'T');
  const utcCandidate = UTC_OFFSET_REGEX.test(normalized) ? normalized : `${normalized}Z`;
  const parsed = new Date(utcCandidate);
  if (!Number.isNaN(parsed.getTime())) return parsed;

  const fallback = new Date(trimmed);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

export const formatUtcDateTime = (value, options = {}) => {
  const parsed = parseBackendUtcDateTime(value);
  if (!parsed) return 'Data non disponibile';

  return parsed.toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  });
};
